import React, { createContext } from 'react';

// Create the FormContext with default values
export const FormContext = createContext({
  options: {
    submit_text: null
  }
});

// Optional provider component for easier usage
export const FormProvider = ({ children, options }) => {
  return (
    <FormContext.Provider value={{ options }}>
      {children}
    </FormContext.Provider>
  );
}; 